<template>
  <div>
    <v-snackbar
      v-model="message.snackbar"
      :timeout="message.snackbarTimeout"
      bottom
    >
      {{ message.snackbarText }}
      <v-btn dark text @click="message.snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="createEventDialog" scrollable max-width="500px">
      <v-card>
        <v-card-title>Create event</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert type="error" class="mt-5" v-if="showEventMessage" dense
            >Duplicate event code entered</v-alert
          >
          <v-form ref="createEventForm">
            <v-text-field
              v-model="companyEventForm.name"
              label="Event name"
              :rules="[rules.required]"
              required
            ></v-text-field>

            <v-select
              v-model="companyEventForm.type"
              :items="eventTypes"
              :rules="[rules.required]"
              label="Type"
            ></v-select>

            <v-text-field
              v-model="companyEventForm.code"
              label="Code"
              :rules="[rules.required]"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="createEventDialog = false"
            class="hp--btn"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="onCreateEvent()"
            class="hp--btn"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="updateEventCodeDialog" scrollable max-width="500px">
      <v-card>
        <v-card-title>Update event code</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert
            type="error"
            class="mt-5"
            v-if="showUpdateEventCodeMessage"
            dense
            >Duplicate event code entered</v-alert
          >
          <v-form ref="updateEventCode">
            <v-text-field
              v-model="updateEventCode.code"
              label="Code"
              :rules="[rules.required]"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="updateEventCodeDialog = false"
            class="hp--btn"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="onUpdateEventCode()"
            class="hp--btn"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="mx-auto" max-width="1000">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            color="info"
            dark
            small
            absolute
            top
            right
            fab
            v-on="on"
            @click="sendMessageToParent"
            class="hp--btn"
          >
            <v-icon>keyboard_return</v-icon>
          </v-btn>
        </template>
        <span>View companies</span>
      </v-tooltip>

      <v-toolbar flat>
        <v-toolbar-title class="grey--text">Events</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              dark
              small
              absolute
              bottom
              fab
              v-on="on"
              @click="createEventDialog = !createEventDialog"
              class="hp--btn"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create event</span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <div v-for="event in events" :key="event.id">
          <v-layout row wrap class="ma-1">
            <v-flex xs12 sm5 lg6>
              <div class="caption grey--text">Name</div>
              <div class="black--text">{{ event.name }}</div>
            </v-flex>
            <v-flex xs12 md1 lg1>
              <div class="caption grey--text">Code</div>
              <div class="black--text">{{ event.code }}</div>
            </v-flex>
            <v-flex xs12 md1 lg1>
              <div class="caption grey--text">Status</div>
              <div class="black--text" v-if="event.status">
                {{ event.status }}
              </div>
            </v-flex>
            <v-flex xs12 md2 lg2>
              <div class="caption grey--text">Type</div>
              <div class="black--text">
                {{ getEventTypeLabel(event.type) }}
              </div>
            </v-flex>
            <v-flex xs12 sm3 lg2>
              <div class="float-right">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mx-1 hp--btn"
                      fab
                      dark
                      x-small
                      color="success"
                      @click="editEvent(event)"
                    >
                      <v-icon v-on="on" dark>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit event</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mx-1 hp--btn"
                      fab
                      dark
                      x-small
                      color="error"
                      @click="deleteEvent(event)"
                    >
                      <v-icon v-on="on" dark>delete_outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete event</span>
                </v-tooltip>
              </div>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import * as mutations from "./../graphql/mutations";
import { Company } from "../classes/Company";
export default {
  props: {
    company: Object,
  },
  data() {
    return {
      events: [],
      eventTypes: [
        { text: "Slot", value: "slot" },
        { text: "Workshop", value: "workshop" },
        { text: "Register Interest", value: "register" },
        { text: "Health Screening", value: "healthscreening" },
        { text: "Virus Testing", value: "virustesting" },
      ],
      createEventDialog: false,
      updateEventCodeDialog: false,
      showEventMessage: false,
      companyEventForm: [],
      showUpdateEventCodeMessage: false,
      updateEventCode: [],
      rules: {
        required: (v) => !!v || "This field is required.",
        email: (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      },
      message: {
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 3000,
      },
    };
  },
  created() {
    const that = this;
    this.events = [];

    const getEventCompany = `query GetEventCompany($id: ID!) {
        getEventCompany(id: $id) {
          id
          name
          createdAt
          logo
          email
          isDeleted
          event(
            filter: {
              isDeleted: { eq: 0 }
            }
          ) {
            items {
              id
              name
              code
              type
              status
              requireDob
              iCalendar
              status
              description
              commsTemplate
              createdAt
              isDeleted
            }
          }
        }
      }
      `;

    API.graphql(
      graphqlOperation(getEventCompany, {
        id: this.company.id,
      })
    ).then((result) => {
      result.data.getEventCompany.event.items.forEach(function (event) {
        that.events.push({
          id: event.id,
          name: event.name,
          code: event.code,
          type: event.type,
          status: event.status,
          requireDob: event.requireDob,
        });
      });
      that.events = _.orderBy(that.events, "name", "asc"); // Lodash sort
    });
  },
  methods: {
    sendMessageToParent() {
      this.$emit("switchEventPanel", "companies");
    },
    editEvent(event) {
      this.$router.push({
        name: "event",
        params: { eventType: event.type.toLowerCase(), eventId: event.id },
      });
    },
    editEventCode(event) {
      this.updateEventCode.code = event.code;
      this.updateEventCode.id = event.id;

      this.updateEventCodeDialog = true;
    },
    async onCreateEvent() {
      if (this.$refs.createEventForm.validate()) {
        const isDuplicate = await new Company().isDuplicateCode(
          this.companyEventForm.code.toLowerCase().trim()
        );
        this.showEventMessage = false;
        if (isDuplicate) {
          this.showEventMessage = true;
          return;
        }
        API.graphql(
          graphqlOperation(mutations.createEvent, {
            input: {
              name: this.companyEventForm.name,
              code: this.companyEventForm.code.toLowerCase().trim(),
              type: this.companyEventForm.type,
              status: "Draft",
              eventEventCompanyId: this.company.id,
              requireDob: true,
              isDeleted: 0,
              createdAt: new Date().toISOString(),
            },
          })
        ).then((result) => {
          this.events.push({
            id: result.data.createEvent.id,
            name: result.data.createEvent.name,
            code: result.data.createEvent.code,
            type: result.data.createEvent.type,
            status: result.data.createEvent.status,
            eventCompany: result.data.createEvent.eventCompany,
            requireDob: result.data.createEvent.requireDob,
            createdAt: result.data.createEvent.createdAt,
          });
          this.events = _.orderBy(this.events, "name", "asc");
          this.createEventDialog = false;
          this.showSuccessMessage(
            "New event " + result.data.createEvent.name + " created"
          );
        });
      }
    },
    async onUpdateEventCode() {
      const that = this;
      if (this.$refs.updateEventCode.validate()) {
        const code = this.updateEventCode.code.toLowerCase().trim();
        const isDuplicate = await new Company().isDuplicateCode(code);
        this.showUpdateEventCodeMessage = false;
        if (isDuplicate) {
          this.showUpdateEventCodeMessage = true;
          return;
        }
        if (this.updateEventCode.id) {
          API.graphql(
            graphqlOperation(mutations.updateEvent, {
              input: {
                id: this.updateEventCode.id,
                code: this.updateEventCode.code,
              },
            })
          ).then((result) => {
            const eventResult = result.data.updateEvent;
            const index = that.events.findIndex(
              (event) => event.id === eventResult.id
            );
            that.events[index].code = eventResult.code;
            that.updateEventCodeDialog = false;
          });
        }
      }
    },
    deleteEvent(event) {
      var that = this;
      confirm("Are you sure you want to delete this event?") &&
        API.graphql(
          graphqlOperation(mutations.updateEvent, {
            input: {
              id: event.id,
              isDeleted: 1,
            },
          })
        )
          .then((res) => {
            that.events.splice(that.events.indexOf(event), 1);
            this.showSuccessMessage("Event deleted");
          })
          .catch((err) => console.log(err));
    },
    getEventTypeLabel(type) {
      const filteredType = this.eventTypes.filter((evtype) => {
        return evtype.value === type;
      });
      return filteredType[0].text;
    },
    showSuccessMessage(message) {
      this.message.snackbarText = message;
      this.message.snackbar = true;
    },
  },
};
</script>